import { BaseEntity } from '../base/BaseEntity'
import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import type { PublicationStatusEnum } from '../base/PublicationStatusEnum'
import type { BlogContentType } from './BlogContentType'
import { generateEntityId } from '../generateEntityId'
import { BlogTranscribingMetadata } from './BlogTranscribingMetadata'
import { RelatedEntity } from '../base/RelatedEntity'
import { BlogCategory } from './BlogCategory'

@ObjectType()
@InputType('BlogInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Blog extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('blog') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String })
  title?: string

  @Field(() => String)
  @Prop({ type: String })
  cover?: string

  @Field(() => String)
  @Prop({ type: String })
  contentUrl?: string

  @Field(() => String)
  @Prop({ type: String })
  contentHtml?: string

  @Field(() => String)
  @Prop({ type: String })
  content?: string

  @Field(() => String)
  @Prop({ type: String })
  description?: string

  @Field(() => String)
  @Prop({ type: String })
  declare status?: PublicationStatusEnum

  @Field(() => String)
  @Prop({ type: String })
  contentType?: BlogContentType

  @Field(() => String)
  @Prop({ type: String })
  slug?: string

  @Field(() => String)
  @Prop({ type: String })
  filePath?: string

  @Field(() => BlogTranscribingMetadata, { nullable: true })
  @Prop({ type: BlogTranscribingMetadata })
  transcribingMetadata?: BlogTranscribingMetadata

  @Field(() => BlogCategory, { nullable: true })
  @Prop({ type: RelatedEntity })
  category?: ReturnType<() => BlogCategory | null>
}
